import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=138765dc&"
import script from "./CFooter.vue?vue&type=script&lang=ts&"
export * from "./CFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports